import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    yourPinCodeIs: 'PIN-koden din er',
};

export default fallbackDictionary;
